import React, { useState, useEffect, useMemo } from 'react';

// Efeito de digitação: revela o texto caractere a caractere ao montar.
// - Reserva o espaço do texto completo (span invisível) -> sem layout shift.
// - Percorre por code point (Array.from) para não quebrar emojis.
// - Expõe o texto inteiro via aria-label (leitores de tela não "digitam").
export function TypewriterText({ text = '', speed = 20, className, style }) {
  const chars = useMemo(() => Array.from(text), [text]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
    if (!chars.length) return undefined;
    let i = 0;
    const id = setInterval(() => {
      i += 1;
      setCount(i);
      if (i >= chars.length) clearInterval(id);
    }, speed);
    return () => clearInterval(id);
  }, [chars, speed]);

  return (
    <span
      className={className}
      style={style}
      aria-label={text}
    >
      <span aria-hidden="true">{chars.slice(0, count).join('')}</span>
      <span
        aria-hidden="true"
        style={{ visibility: 'hidden' }}
      >
        {chars.slice(count).join('')}
      </span>
    </span>
  );
}
